import { forwardRef } from 'react';
import StyledTextarea from './styles';
import { Props } from './types';

const Textarea = forwardRef<HTMLDivElement, Props>(
  ({ resize = 'none', fullWidth, ...otherProps }, ref) => {
    return (
      <StyledTextarea
        multiline
        fullWidth={fullWidth}
        resize={fullWidth ? 'none' : resize}
        {...otherProps}
        ref={ref}
      />
    );
  },
);

Textarea.displayName = 'Textarea';

export default Textarea;
